// グローバル参照
declare const wpcf7: any;

/**
 * コンタクトページ
 */
export class Contact {

  /**
   * ファイルリスト
   */
  private files: any = {};

  /**
   * invalid scroll
   */
  private scrollinvalid:number = 0;

  // コンストラクタ
  constructor() {
    if (! $('.wpcf7')[0]) {
      return;
    }

    this.SubmitWrap();
    this.RequiredCheck();
    this.PageChange();
  }

  /**
   * 必須項目判定＊付与
   */
  private RequiredCheck() {
    $('.wpcf7-validates-as-required').closest('td').prev('th').append('*');
    $('.wpcf7-form-control-wrap.acceptance').closest('td').prev('th').text('');
  }

  /**
   * メンバ関数
   * SubmitWrap submit要素を囲む
   */
  private SubmitWrap() {
    $("input[type='submit']").before("<div class='p-form__button p-form--submit__button'> <a class='fn-submit'><span>"+ $("input[type='submit']").val() +"</span></a></div>");
  }

  /**
   * メンバ関数
   * PageChange ページ切り替え
   * 入力 → 確認 → 完了
   */
  private PageChange(): void {
    // === 入力ページの時 ===

    // 入力ページのconfirmボタンが押された
    $('.fn-submit').on('click', this.validate);

    // === 確認ページの時 ===

    // 確認ページで前に戻る
    $('.fn-back').on('click', (event: any): void => {
      // section を 非表示
      $(event.currentTarget).closest('section').addClass('is-invisible');
      // 次の section を表示
      $(event.currentTarget).closest('section').prev().removeClass('is-invisible');
      $(window).scrollTop(0);
      // ヘッダ背景を再表示
      setTimeout((): void => {
        if ($('.c-entry-back').hasClass('is-invisible')) {
          $('.c-entry-back').removeClass('is-invisible');
        }
      }, 300);
    });

    // 確認ページで次に進む
    $('.fn-next').on('click', (event: any): void => {
      // submit
      $('[type="submit"]').trigger('click');
    });

    // バリデートエラー
    $('.wpcf7').on('wpcf7invalid wpcf7unaccepted wpcf7aborted', (event: any): void => {
      $('.wpcf7-form-control-wrap.file').each((index: number, element: Element): void => {
        try {
          const file: any = this.files['file_' + index];

          if (file) {
            $(element).append(file);
          }
        } catch (e) {}
      });
      this.files = {};

      // privacy invalidMessageChange
      $('.wpcf7-acceptance').next('.wpcf7-not-valid-tip').text('必須項目に入力してください。');

      // invalid scroll
      $('.wpcf7-not-valid-tip').each((i: any, elm: any) => {
        if (i == 0) {
          this.scrollinvalid = $(elm).closest('tr').offset()!.top;
        } else {
          var offsettop = $(elm).closest('tr').offset()!.top;

          if (this.scrollinvalid > offsettop) {
            this.scrollinvalid = offsettop;
          }
        }
      });
      $(window).scrollTop( this.scrollinvalid - $('header').height());
    });

    // === 完了ページの時 ===

    // メール送信エラー
    $('.wpcf7').on('wpcf7mailfailed', (event: any): void => {
      alert('メール送信エラー');
    });

    // メールが送信された
    $('.wpcf7').on('wpcf7mailsent', (event: any): void => {
      // section を 非表示
      $('.p-form--confirmation').addClass('is-invisible');
      // 次の section を表示
      $('.p-form--confirmation').next().removeClass('is-invisible');
      $(window).scrollTop(0);
      // ヘッダ背景を再表示
      setTimeout((): void => {
        if ($('.c-entry-back').hasClass('is-invisible')) {
          $('.c-entry-back').removeClass('is-invisible');
        }
      }, 300);
    });

    // === wpcf7submit ===

    // wpcf7submit
    $('.wpcf7').on('wpcf7submit', (): void => {
      $('.fn-submit').on('click', this.validate);
    });
  }

  /**
   * バリデート
   */
  private validate = (): void => {
    $('.fn-submit').off('click', this.validate);

    $('.wpcf7-form-control-wrap.file').each((index: number, element: Element): void => {
      const $file = $(element).find('input[type="file"]');

      if (! $file.val()) {
        try {
          this.files['file_' + index] = $file.clone(true);
          $file.remove();
        } catch (e) {}
      }
    });

    const form: any = $('.wpcf7-form')[0];
    const formData: any = new FormData(form);
    const id: any = parseInt($('input[name="_wpcf7"]').val());

    $.ajax({
      type: 'POST',
      url: wpcf7.apiSettings.getRoute(`/contact-forms/${id}/validate`),
      data: formData,
      dataType: 'json',
      processData: false,
      contentType: false
    }).done((data: any, status: any, xhr: any): void => {
      if (! data.status) {
        // エラー表示
        $('[type="submit"]').trigger('click');
      } else {
        // 入力内容ペースト関数
        this.valuePaste();
        // エラー非表示
        $('.wpcf7-not-valid-tip').hide();
        $('.wpcf7-validates-as-required').removeClass('wpcf7-not-valid');
        // section を 非表示
        $(form).closest('section').addClass('is-invisible');
        // 次の section を表示
        $(form).closest('section').next().removeClass('is-invisible');
        $(window).scrollTop(0);
        // ヘッダ背景を再表示
        setTimeout((): void => {
          if ($('.c-entry-back').hasClass('is-invisible')) {
            $('.c-entry-back').removeClass('is-invisible');
          }
        }, 300);
        $('.fn-submit').on('click', this.validate);
        $('.wpcf7-form-control-wrap.file').each((index: number, element: Element): void => {
          try {
            const file: any = this.files['file_' + index];

            if (file) {
              $(element).append(file);
            }
          } catch (e) {}
        });
        this.files = {};
      }
    });
  }

  /**
   * 入力内容ペースト関数
   */
  private valuePaste(): void {
    // submit された時点で問題なければ

    // 確認画面側のテーブル
    const tableMake = $('.fn-tableMake');

    try {
      tableMake.find('tr').remove();
    } catch (e) {}

    // 入力側 tr ごとに each 
    $('form table tr').each((i: any, elm: any): void => {
      // th 用
      const tr = $('<tr>');
      tr.append($(`<th>${$(elm).children('th').text()}</th>`));
      // td 用
      var td = $(elm).children('td');
      // 要素取得
      var input = td.find('input');
      var select = td.find('select');
      var textarea = td.find('textarea');
      var text = '';

      // input
      if (input.length && ! td.find('.wpcf7-acceptance')[0]) {
        // text
        var type = input.attr('type');

        if (type == 'text' || type == 'tel' || type == 'url' || type == 'email') {
          text = input.val();
        } else if (type == 'radio') {
          $(td).find('.wpcf7-list-item').each((i, elm): void => {
            var checked = $(elm).find('input').prop('checked');

            if (checked) {
              text = $(elm).find('input').val();
            }
          });
        } else if (type == 'checkbox') {
          $(td).find('.wpcf7-list-item').each((i, elm): void => {
            var checked = $(elm).find('input').prop('checked');

            if (checked) {
              text += $(elm).find('input').val() + '<br>';
            }
          });
        } else if (type == 'file') {
          text = input.val();
        }
      }

      // select
      if (select.length) {
        $(td).find('.wpcf7-form-control-wrap').each((i, elm): void => {
          var checked = $(elm).find('select option:selected').prop('selected');
          console.log(checked);

          if (checked) {
            text += $(elm).find('select option:selected').val() + '<br>';
          }
        });
      }

      // textarea
      if (textarea.length) {
        text = textarea.val();
      }

      // td 代入
      tr.append($(`<td>${text}</td>`));
      tableMake.append(tr);
    });
  }

}
